import { stepMedicalExpenseCFLookup as expenseLookup } from './claimCodeMapper';

function mapToParentSection() {
  return {};
}

function mapToQuestionnaire(data, claimCode) {
  const questionnaire = [];
  const entries = Object.entries(data);
  const excludedEntries = ['prescriptionMedicinesNotInjury',
    'prescriptionMedicinesForInjury',
    'lossInformationItemsMedicalExpense',
  ];
  entries.forEach(([property, value]) => {
    if (excludedEntries.indexOf(property) < 0) {
      questionnaire.push({
        question: `section13.${property}`,
        answer: value,
        claimTypeCode: claimCode,
      });
    }
  });
  return [...questionnaire];
}

function mapToExpenses(data) {
  const medicalExpenses = mapToMedicalExpenseStep(data);

  return [...medicalExpenses];
}

function mapToMedicalExpenseStep(data) {
  const expenses = [];
  const lossInformationItems = data.lossInformationItemsMedicalExpense || [];

  if (lossInformationItems.length < 1) {
    return expenses;
  }

  if (lossInformationItems.length < 1) {
    return expenses;
  }
  const claimCode = expenseLookup.medicalExpenseCF.claimCode;
  lossInformationItems.forEach(
    (item) => {
      const expense = mapLossItemExpense(item, data, claimCode);
      if (!!expense) {
        expenses.push(expense);
      }
    }
  );
  return expenses;
}

function mapLossItemExpense(item, formData, claimCode) {
  return mapExpenseItem(item, formData.dateIncurred, claimCode);
}

function mapExpenseItem(item, itemDate, claimCode) {
  if (!item || !item.actualCostForHospital || !item.currencyForHospital) {
    return null;
  }
  return {
    shortDescription: `${item.medicalProviderName}`,
    dateOfExpense: item.expenseDateForHospital,
    clientCost: item.actualCostForHospital,
    currency: item.currencyForHospital,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
  };
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepMedicalExpenseCFDataMapper.js